import React from "react"
import { connect } from "react-redux"
import { range } from "lodash"
import { User } from "react-feather"

import { push } from "connected-react-router"
import CoolPage from "../components/CoolPage"
import habitaciones from "./rooms"

import "./TepaRooms.less"

// I want this icon inline to change its color from css
// it's just like Feather's icon, but thicker
const CustomUserIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
)

class TepaRooms extends React.PureComponent {
  render() {
    return (
      <CoolPage
        containerProps={{ className: "tepa" }}
        title="客房"
        fixedBar="true"
        className="tepaPage"
      >
        <div className = "tepa-rooms-2" >
          <div className="rooms" >
            {
              habitaciones.map(({ people, key, title, subtitle, size, details, imagen }) => (
                <div key={title} className="envoltorio ">
                  <div
                    className="room"
                    onClick={() => this.props.gotoRoom(key)}
                  >
                    <div className={"image-room " + imagen} />
                    <article>
                      <h1>{title}</h1>
                      <div className="people-icon">
                        {
                          range(0, people).map(i => (
                            /*<User key={i} />*/
                            <CustomUserIcon key={i} />
                          ))
                        }
                      </div>
                      <h2>{subtitle}</h2>
                      <p>
                        <img src="/static/img/nh/icon_map_small.svg"/>
                        {size}
                      </p>
                      <p>
                        <img src="/static/img/nh/icon_cama_small.svg"/>
                        {details}
                      </p>
                    </article>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </CoolPage>
    )
  }
}

const mapStateToProps = (_state, _ownProps) => ({ })

const mapDispatchToProps = dispatch => {
  const goto = url => dispatch(push(url))
  return {
    goto,
    gotoRoom: key => goto(`/catalogo/room/${key}`),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TepaRooms)



// WEBPACK FOOTER //
// ./src/app/catalogo/hotels/TepaRooms.jsx